<template>
    <VueDraggable
        v-bind="draggableData"
        v-model="list"
        class="sbs-draggable"
    >
        <!-- @slot Слот для элементов драглиста -->
        <slot v-bind="{ list }"></slot>
    </VueDraggable>
</template>

<script>
import { VueDraggable } from 'vue-draggable-plus';

/**
 * Стандартный список элементов с возможностью перетаскивания
 */
export default {
    name: 'SbsDraggable',
    components: {
        VueDraggable,
    },
    emits: ['update:modelValue', 'input'],
    computed: {
        list: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
        defaultDraggableOptions() {
            return {
                animation: 200,
                fallbackOnBody: true,
            };
        },
        draggableData() {
            return {
                ...this.defaultDraggableOptions,
                ...this.$attrs,
            };
        },
    },
    inheritAttrs: false,
    props: {
        /**
         * Список элементов
         * @model
         */
        modelValue: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style lang="scss">
.sortable-ghost {
    opacity: 0.5;
}
</style>
